import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, initializing, isFirebaseConfigured } = useAuth();

  if (!isFirebaseConfigured) {
    return (
      <div className="loading-state">
        <p>प्रशासनिक सेवा अनुपलब्ध है।</p>
        <span className="caption">
          Admin services require Firebase configuration.
        </span>
      </div>
    );
  }

  if (initializing) {
    return (
      <div className="loading-state">
        <p>लोड हो रहा है...</p>
        <span className="caption">Loading…</span>
      </div>
    );
  }

  return user ? children : <Navigate to="/admin/login" replace />;
};

export default ProtectedRoute;
